import React from "react";
import styles from "./AutoRenewal.scss";
import { useDispatch, useSelector } from "react-redux";
import { autoRenewal, getUserProfile, selectLoadedUser } from "../../../../routes/Auth/auth.ducks";
import { UserI } from "../../../../typings/interfaces";
import confirmModal from "../../../../services/confirmModal";
import { PageRoute, QueryParam } from "../../../../models";
import history from "../../../../history";
import { checkEmptyObject } from "../../../../services";
import { StaticHTML } from "../../../../components";
import ReactGA from "react-ga4";
import { Button as PrimaryButton } from "../../../../components/Button/Button";
import { Button } from "antd";


export interface IAutoRenewal {
  user: UserI;
}

const minStoreCreditForAutoRenewal = 0.1;

const AutoRenewal = (props: IAutoRenewal) => {
  const dispatch = useDispatch();
  const user: UserI = useSelector(selectLoadedUser);

  const handleAutoRenewalActivation = () => {
    confirmModal.show({
      title: "Automatska obnova oglasa",
      okText: user.storeCreditBalance >= minStoreCreditForAutoRenewal ? "Aktiviraj" : "Kupi kredite",
      cancelText: "Odustani",
      iconType: "NaN",
      okButtonProps: {
        className: styles.okButton
      },
      cancelButtonProps: {
        className: styles.cancelButton
      },

      onOk() {
        if (user.storeCreditBalance >= minStoreCreditForAutoRenewal) {
          dispatch(autoRenewal(!user.autoRenewal, () => {
            dispatch(getUserProfile({}, null, true));
            ReactGA.event({
              category: "Automatska obnova oglasa",
              action: "Click",
              label: "Aktivacija"
            });
          }));
        } else {
          history.push({
            pathname: PageRoute.credits,
            state: { redirectAfterCreditPurchase: history.location.pathname }
          });
        }
      },
      children: <StaticHTML content={(user.storeCreditBalance >= minStoreCreditForAutoRenewal ?
        "Automatska obnova oglasa moguća je za sve kategorije oglasa. Aktivacijom će se svi vaši oglasi, koji trebaju isteći, automatski obnoviti na novih 30 dana.{0}{0}Obnova svakog oglasa skida {1} kredit s vašeg salda.{0}{0}Obnovom, oglas skače u vrh novih oglasa i postaje vidljiviji." :
        "Za automatsku obnovu oglasa potrebno je imati kredite na računu. Obnova je dostupna za sve kategorije, a oglasi koji trebaju isteći automatski će se obnoviti.{0}{0}Svaka obnova skida {1} kredit, a oglas se podiže na vrh novih oglasa i postaje vidljiviji."
      ).replaceAll("{0}", "<br />").replaceAll("{1}", minStoreCreditForAutoRenewal.toString())
      } />,
    });
  }

  const handleAutoRenewalDeactivation = () => {
    confirmModal.show({
      title: "Automatska obnova oglasa",
      okText: "Deaktiviraj",
      cancelText: "Odustani",
      iconType: "NaN",
      okButtonProps: {
        className: styles.okButton
      },
      cancelButtonProps: {
        className: styles.cancelButton
      },

      onOk() {
        dispatch(autoRenewal(!user.autoRenewal, () => {
          dispatch(getUserProfile({}, null, true));
          ReactGA.event({
            category: "Automatska obnova oglasa",
            action: "Click",
            label: "Deaktivacija"
          });
        }));
      },
      children: <StaticHTML content={
        "Deaktivacijom automatske obnove oglasa, svi vaši oglasi koji su do sada bili automatski obnovljeni više se neće automatski obnavljati.{0}{0}Vaši oglasi ostat će aktivni do isteka njihovog trajanja, nakon čega će se deaktivirati.{0}{0}Oglase uvijek možete ručno obnoviti prema potrebi.".replaceAll("{0}", "<br />")
      } />,
    });
  }

  return !checkEmptyObject(user) || !user.eligibleForAutoRenewal ? null : (
    <div className={styles.container}>
      {"Želite automatsku mjesečnu obnovu oglasa?"}

      {user.autoRenewal ? (
        <Button
          className={styles.button}
          type="default"
          onClick={handleAutoRenewalDeactivation}
        >{"Deaktiviraj automatsku obnovu"}
        </Button>

      ) : (
        <PrimaryButton
          className={styles.button}
          onClick={handleAutoRenewalActivation}
          type="primary"
        >{"Aktiviraj automatsku obnovu"}
        </PrimaryButton>

      )}
    </div>
  );
};


AutoRenewal.defaultProps = {
  user: {},
};

export default AutoRenewal;



// WEBPACK FOOTER //
// ./src/containers/MyAdsPage/MyAds/AutoRenewal/AutoRenewal.tsx